import { observable, action, computed } from 'mobx';

class CalendarStore {
  @observable meetings = null;
  @observable limit = 10;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action loadCalendar = (authUser, firebase) => {
    firebase
      .meetings(authUser.uid)
      .orderByChild('createdAt')
      .limitToLast(this.limit)
      .on('value', snapshot => {
        this.meetings = snapshot.val();
      });
  }

  @action setLimit = limit => {
    this.limit = limit;
  };

  @computed get meetingList() {
    return Object.keys(this.meetings || {}).map(key => ({
      ...this.meetings[key],
      uid: key,
    }));
  }
}

export default CalendarStore;
